import { ReportDetailPage } from "~/features/reports/components/report-detail/report-detail-page.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { RoleGuard } from "~/shared/components/role-guard/role-guard.tsx";
import { REPORTS_ROLES } from "~/shared/constants/page-roles.ts";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export function ReportsDetailPage() {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlReportsPage");
	const { isInternal } = useDeploymentType();

	if (!isReady) {
		return <LoadingSpinner />;
	}

	if (!isEnabled) {
		return <Construction />;
	}

	if (isInternal) {
		return <ReportDetailPage />;
	}

	return (
		<RoleGuard allowedRoles={REPORTS_ROLES}>
			<ReportDetailPage />
		</RoleGuard>
	);
}
